var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99609 5.5625H14.3438C14.6172 5.5625 14.8633 5.75391 14.9453 6.02734C15.0547 6.27344 14.9453 6.57422 14.7266 6.73828L11.1445 9.52734L12.5391 13.9023C12.6484 14.1758 12.5391 14.4766 12.293 14.6406C12.0742 14.8047 11.7461 14.8047 11.5273 14.6133L8 11.8789L4.44531 14.6133C4.22656 14.8047 3.89844 14.8047 3.67969 14.6406C3.43359 14.4766 3.32422 14.1758 3.43359 13.9023L4.82812 9.52734L1.24609 6.73828C1.02734 6.57422 0.917969 6.27344 1.02734 6.02734C1.10938 5.75391 1.35547 5.5625 1.65625 5.5625H5.97656L7.37109 1.21484C7.45312 0.941406 7.69922 0.75 8 0.75C8.27344 0.75 8.51953 0.941406 8.60156 1.21484L9.99609 5.5625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.ce11ad0a773b98c56a44b7d023467eaf.svg";
export { ForwardRef as ReactComponent };